import { Injectable } from '@angular/core';
import {
    ROUTE_DEFAULT, ROUTE_IMPERS_DEFAULT,
    ROUTE_MARKETING_DEFAULT,
    ROUTE_SERVICE_DEFAULT, ROUTE_SUBSIDIARY_DEFAULT, ROUTE_TECHNICIAN_DEFAULT, ROUTE_USER_DEFAULT,
} from '../conf/user';
import { CCRoute } from '../model/cc-route';
import { RoleExplained } from '../model/role';

@Injectable({
    providedIn: 'root'
})
export class RouteService {

    correctRoute(role: RoleExplained, currentTechnician: boolean, sReturnUrl: string): CCRoute {
        if (sReturnUrl) {
            const returnUrl = JSON.parse(sReturnUrl);
            if (this.checkUserRoute(role, currentTechnician, returnUrl)) {
                return { path: [returnUrl.path], queryParams: returnUrl.queryParams};
            } else {
                return this.defaultRoute(role, currentTechnician);
            }
        } else {
            return this.defaultRoute(role, currentTechnician);
        }
    }

    checkUserRoute(role: RoleExplained, currentTechnician: boolean, returnUrl: any): boolean {
        if (!returnUrl.path) {
            return false;
        }
        const returnPath = returnUrl.path.split('/');
        let rootPath = returnPath[0] || returnPath[1];
        if (!rootPath) {
            return false;
        }
        rootPath = `/${rootPath}`;
        if (role.isUser) {
            if (currentTechnician) {
                return ROUTE_IMPERS_DEFAULT[0] === rootPath;
            } else {
                return ROUTE_USER_DEFAULT[0] === rootPath;
            }
        } else if (role.isTechnician) {
            return ROUTE_TECHNICIAN_DEFAULT[0] === rootPath;
        } else if (role.isService) {
            return ROUTE_SERVICE_DEFAULT[0] === rootPath;
        } else if (role.isSubsidiary) {
            return ROUTE_SUBSIDIARY_DEFAULT[0] === rootPath;
        }else if (role.isMarketing) {
            return ROUTE_MARKETING_DEFAULT[0] === rootPath;
        }
        return false;
    }

    defaultRoute(role: RoleExplained, currentTechnician: boolean): CCRoute {
        if (role.isUser) {
            if (currentTechnician) {
                return { path: ROUTE_IMPERS_DEFAULT, queryParams: {} };
            } else {
                return { path: ROUTE_USER_DEFAULT, queryParams: {} };
            }
        } else if (role.isTechnician) {
            return { path: ROUTE_TECHNICIAN_DEFAULT, queryParams: {} };
        } else if (role.isService) {
            return { path: ROUTE_SERVICE_DEFAULT, queryParams: {} };
        } else if (role.isSubsidiary) {
            return { path: ROUTE_SUBSIDIARY_DEFAULT, queryParams: {} };
        } else if (role.isMarketing) {
            return { path: ROUTE_MARKETING_DEFAULT, queryParams: {} };
        } else {
            return { path: ROUTE_DEFAULT, queryParams: {} };
        }
    }
}
